import React, { Component } from 'react'
import styled from 'styled-components'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import moment from 'moment'
import { isEmpty } from 'ramda'
import { Colors, Table, TableCell, TableHeader, TableLoading,
  TableExpander, TextIcon, Button, Pagination, RoundedTabs } from 'advenio-components'
import { connect } from 'react-redux'
import UnvalidatedReceiptsActions from '../../Data/Redux/UnvalidatedReceiptsRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CountriesActions from '../../Data/Redux/CountriesRedux'
import BalanceActions from '../../Data/Redux/BalanceRedux'
import CenterActions from '../../Data/Redux/CenterRedux'
import StudentReceiptDetail from './StudentReceiptDetail'
import AdjustModal from './AdjustModal'

const ReceiptId = styled.span`
  color: ${Colors.red500};
`
const TableContainer = styled.div``
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.blue500};
  cursor: pointer;
`
const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const Container = styled.div`
  padding: 32px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  font-size: 30px;
  font-weight: bold;
  flex-direction: row;
  align-items: center;

  span {
    margin-right: 10px;
  }
`

class UnvalidatedReceipts extends Component {
  state = {
    selectedId: 0,
    expanded: [],
    firstPageToRender: 1,
    lastPageToRender: 10,
    pageSelected: 1,
    queryParams: {},
    openModal: false,
    isMexican: false,
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    const {
      center,
      getCenter,
      getClassrooms,
      getCountries,
      getReceipts,
      user,
    } = this.props

    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }

    this.setState({ queryParams })
    // Send API request with query param: without_retention in order to return original totals
    getReceipts({ without_retention: true, ...queryParams })
    // getClassrooms()
    getCountries()

    if (isEmpty(center)) {
      getCenter(user.center_id)
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.countries && nextProps.user) {
      const country = nextProps.countries.find(c => c.id === nextProps.user.country_id)
      if (country && country.name === 'Mexico') {
        this.setState({ isMexican: true })
      }
    }

    if (nextProps.user !== this.props.user) {
      this.props.getCenter(nextProps.user.center_id)
    }
  }

  onClickPage = (pageSelected) => {
    this.setState({ pageSelected }, () => {
      const queries = { ...this.state.queryParams, page: pageSelected }

      this.props.getReceipts(queries)
      this.props.goTo(`?${queryString.stringify(queries)}`)
    })
  }

  navigateToProfile = (student, fromReceipt) => {
    const { goTo, setActiveStudentId, setActiveClassroomId, sendToAccount } = this.props
    const { classroom_id: classroomId, id: studentId } = student

    setActiveStudentId(Number(studentId))
    setActiveClassroomId(Number(classroomId))

    if (fromReceipt) {
      goTo(`/classroom/${classroomId}/student/${studentId}`)
      return sendToAccount()
    }

    return goTo(`/classroom/${classroomId}/student/${studentId}`)
  }

  validateReceipt = (index, id) => {
    this.props.validateReceipt(id)
    this.toggleViewReceiptDetail(index)

    const newState = { ...this.state }
    newState.expanded[index + 1] = true
    this.setState(newState)
  }

  toggleViewReceiptDetail = (index) => {
    const newState = { ...this.state }

    newState.expanded[index] = !newState.expanded[index]

    this.setState(newState)
  }

  adjust = (receipt) => {
    this.setState({
      selectedReceipt: receipt,
      openModal: true,
    })
  }

  closeModal = () => {
    this.setState({
      openModal: false,
    })
  }

  goTo = (e) => {
    this.props.goTo(e.currentTarget.id)
  }

  render() {
    const { adjustTransaction, center, center: { currency }, consumables, loading, meta,
      paymentTypes, receipts, sending } = this.props
    const { expanded, isMexican, openModal, pageSelected, selectedReceipt } = this.state

    return (
      <Container>
        <HeaderContainer>
          <span>
            Validación de recibos
          </span>
          <RoundedTabs
            selectedTab={'/unvalidated-receipts'}
            tabs={[
              {
                id: '/unvalidated-receipts',
                title: 'Por validar',
              },
              {
                id: '/validated-receipts',
                title: 'Validados',
              },
            ]}
            onClick={this.goTo}
          />
        </HeaderContainer>
        <TableContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {loading ?
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Fecha de pago',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: '# de Recibo',
                  element: 'Text',
                  center: false,
                },
                {
                  id: 3,
                  header: 'Alumno',
                  element: 'Text',
                  center: false,
                },
                {
                  id: 4,
                  header: 'Monto',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: '',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
            :
            <Table
              roundedCorners
              SubComponent={HOC(StudentReceiptDetail, this.validateReceipt, this.adjust)}
              data={receipts}
              expanded={expanded}
              columns={[
                {
                  id: 1,
                  expander: true,
                  Header: () => <TableHeader blue />,
                  Expander: ({ isExpanded, ...rest }) => (
                    <TableCell>
                      <TableExpander
                        id={rest.index}
                        open={isExpanded}
                        openCard={() => this.toggleViewReceiptDetail(rest.index)}
                      />
                    </TableCell>
                  ),
                },
                {
                  id: 2,
                  Header: () => <TableHeader title="Fecha de pago" blue />,
                  accessor: ({ created_at }) => ({ created_at }),
                  Cell: ({ value: { created_at } }) =>
                    <TableCell>{moment(created_at).format('YYYY-MM-DD HH:mm')}</TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 3,
                  Header: () => <TableHeader title="# de Recibo" blue />,
                  accessor: ({ id }) => ({ id }),
                  Cell: ({ value: { id } }) => <TableCell ><ReceiptId>{id}</ReceiptId></TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 4,
                  Header: () => <TableHeader title="Alumno" blue />,
                  accessor: ({ student, parent }) => ({ student, parent }),
                  Cell: ({ value: { student, parent } }) => (
                    <TableCell >
                      <InfoCell>
                        <InfoRow>
                          <StudentName onClick={() => this.navigateToProfile(student)}>
                            {student && student.name}
                          </StudentName>
                        </InfoRow>
                        <InfoRow>
                          Tutor: <ParentName>{parent && parent.name}</ParentName>
                        </InfoRow>
                      </InfoCell>
                    </TableCell>
                  ),
                },
                {
                  id: 5,
                  Header: () => <TableHeader title="Monto" blue center />,
                  accessor: ({ total_formatted }) => ({ total_formatted }),
                  Cell: ({ value: { total_formatted } }) =>
                    <TableCell center>{total_formatted}</TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 6,
                  Header: () => <TableHeader blue />,
                  accessor: ({ id, validated_at: isValidated }) => ({ id, isValidated }),
                  maxWidth: 200,
                  Cell: ({ value: { id, isValidated }, index }) => (
                    <TableCell center>
                      {isValidated
                        ? <ValidatedText
                          label="Validado"
                          iconType="checkmark"
                          iconViewBox="0 1 18 18"
                          iconColor={Colors.green500}
                        />
                        : <Button
                          id={id}
                          onClick={() => this.toggleViewReceiptDetail(index)}
                          marginLeft="0"
                          marginRight="0"
                          success
                          small
                        >
                          Ver Recibo
                        </Button>
                      }
                    </TableCell>
                  ),
                },
              ]}
            />
          }
        </TableContainer>
        <AdjustModal
          open={openModal}
          onClose={this.closeModal}
          consumables={consumables}
          tax={center.base_tax_pct}
          receipt={selectedReceipt}
          studentId={selectedReceipt && selectedReceipt.student.id}
          student={selectedReceipt && selectedReceipt.student}
          adjustTransaction={adjustTransaction}
          currency={currency}
          sending={sending}
          isMexican={isMexican}
          paymentTypes={paymentTypes}
        />
      </Container>
    )
  }
}

UnvalidatedReceipts.propTypes = {
  /** The current center */
  center: PropTypes.object,
  /** A listing of supported countries */
  countries: PropTypes.array.isRequired,
  /** A listing of consumables that can be charged to a receipt */
  consumables: PropTypes.array,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** A listing of types of payments that can be used to pay a receipt */
  paymentTypes: PropTypes.array,
  /** The listing of unvalidated receipts */
  receipts: PropTypes.array,
  /** Meta data for the paginated results */
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** React router location information, containing query params etc. */
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** Flag marking whether a request is being sent to the API */
  sending: PropTypes.bool,
  /** The currently authenticated user */
  user: PropTypes.object.isRequired,

  /**
    * Submit an adjustment transaction for the given receipt.
    * This adjustment may be a charge or a payment.
    */
  adjustTransaction: PropTypes.func.isRequired,
  /** Fetch information for the current center */
  getCenter: PropTypes.func.isRequired,
  /** Fetch a listing of all classrooms in this center */
  getClassrooms: PropTypes.func.isRequired,
  /** Fetch a listing of all available countries */
  getCountries: PropTypes.func.isRequired,
  /** Fetch the listing of unvalidated receipts from the API */
  getReceipts: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
  /** Navigate to the given student's profile */
  sendToAccount: PropTypes.func.isRequired,
  /** Set the ID of the student before navigating to their profile */
  setActiveStudentId: PropTypes.func.isRequired,
  /** Set the ID of the active classroom before navigating to a student's profile */
  setActiveClassroomId: PropTypes.func.isRequired,
  /** Submit a request to the API to mark a given receipt as validated */
  validateReceipt: PropTypes.func.isRequired,
}

UnvalidatedReceipts.defaultProps = {
  center: {},
  consumables: [],
  inscriptions: [],
  meta: () => {},
  location: {},
  paymentTypes: [],
  receipts: [],
  sending: false,
}

const mapStateToProps = ({ unvalidatedReceipts, consumables, countries, centers,
  auth, balance, parent_payment_types }) => ({
  receipts: unvalidatedReceipts.get.results.data,
  meta: unvalidatedReceipts.get.results.meta,
  loading: unvalidatedReceipts.get.fetching,
  user: auth.user,
  consumables: consumables.get.results,
  countries: countries.get.results,
  sending: balance.transaction.fetching,
  center: centers.getOne.result,
  paymentTypes: parent_payment_types.get.results,
})

const mapDispatchToProps = dispatch => ({
  getReceipts: query => dispatch(UnvalidatedReceiptsActions.getRequest(query)),
  validateReceipt: id => dispatch(UnvalidatedReceiptsActions.validateRequest(id)),
  getCenter: centerId => dispatch(CenterActions.getOneRequest(centerId)),
  adjustTransaction: (receiptId, data) =>
    dispatch(BalanceActions.adjustTransactionRequest(receiptId, data)),
  sendToAccount: () => dispatch(UnvalidatedReceiptsActions.sendToAccount()),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  getClassrooms: () => dispatch(ClassroomActions.getRequest()),
  goTo: path => dispatch(push(path)),
  getCountries: () => dispatch(CountriesActions.getRequest()),
})

const HOC = (SubComponent, validateReceipt, adjust) => {
  return class extends Component {
    render() {
      return <SubComponent
        {...this.props}
        validateReceipt={validateReceipt}
        adjust={adjust}
      />
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnvalidatedReceipts)



// WEBPACK FOOTER //
// ./src/Containers/ReceiptValidations/UnvalidatedReceipts.jsx